import { Trans, useTranslation } from "react-i18next";
import { useBranding } from "../../contexts/branding";

export default function RegisterLink() {
    const { label, registrationUrl } = useBranding();
    const { t } = useTranslation();

    return (
        <Trans i18nKey="new_account">
            <span className="text-lg">Don&apos;t have an account? </span>
            <a
                href={registrationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={label !== "HabitNu" ? "ada-link text-lg" : "text-lg"}
            >
                {t("Register")}
            </a>
        </Trans>
    );
}
